import {Grid} from '@jetbrains/ring-ui/components/grid/grid'
import * as React from 'react'

import {stringifyId} from '../../../types'
import type {NormalizedAgent} from '../../../types'
import Loader from '../../common/Loader/Loader'

import Agent from './Agent/Agent.container'
import type {AgentsProps, DefaultProps} from './Agents.types'

import styles from './Agents.css'

class Agents extends React.PureComponent<AgentsProps> {
  static defaultProps: DefaultProps = {
    data: [],
    ready: false,
    error: '',
    placeholder: 'No agents available',
    withPool: true,
    withLoader: false,
    processFn: (agents: ReadonlyArray<NormalizedAgent>) => agents,
  }

  render(): React.ReactNode {
    const {
      ready,
      withLoader,
      data,
      placeholder,
      sorting,
      processFn,
      withPool,
      isFirst,
      collapsedPools,
      displayConnectionStatus,
    } = this.props
    const processedData = processFn(data, sorting)
    let agentsToRender = processedData

    if (collapsedPools) {
      agentsToRender = processedData.filter(agent => !collapsedPools.includes(agent.pool.id!))
    }

    if (!ready) {
      return withLoader ? <Loader /> : null
    } else if (!processedData.length) {
      return <div className={styles.placeholder}>{placeholder}</div>
    }

    return (
      <Grid className={styles.agents}>
        {agentsToRender.map((agent, index) => (
          <Agent
            isFirst={isFirst === true && index === 0}
            agentId={agent.id}
            key={stringifyId(agent.id)}
            withPool={withPool}
            hideTopBorder={!withPool && index === 0}
            displayConnectionStatus={displayConnectionStatus}
          />
        ))}
      </Grid>
    )
  }
}

export default Agents
